import classNames from 'classnames';
import { forwardRef, InputHTMLAttributes, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import "../../../styles/styles.css";

interface PasswordInputProps {
    name: string;
    placeholder?: string;
    refCallback?: any;
    register?: any;
    className?: string;
    errorText?: string;
    onKeyDown?: (e: React.KeyboardEvent) => void;
}

/* Password Input */
const PasswordInput = ({
    name,
    placeholder,
    refCallback,
    register,
    className,
    errorText,
    onKeyDown,
    ...otherProps
}: PasswordInputProps) => {
    const [showPassword, setShowPassword] = useState<boolean>(false);

    return (
        <>
            <InputGroup className="mb-0">
                <Form.Control
                    type={showPassword ? 'text' : 'password'}
                    placeholder={placeholder}
                    name={name}
                    id={name}
                    as="input"
                    onKeyDown={onKeyDown}
                    ref={(r: HTMLInputElement) => {
                        if (refCallback) refCallback(r);
                    }}
                    className={className}
                    {...(register ? register(name) : {})}
                    autoComplete={name}
                    {...otherProps}
                />
                <div
                    className={classNames('input-group-text', 'input-group-password', {
                        'show-password': showPassword,
                    })}
                    data-password={showPassword ? 'true' : 'false'}
                >
                    <span
                        className="password-eye"
                        onClick={() => {
                            setShowPassword(!showPassword);
                        }}
                    ></span>
                </div>
            </InputGroup>
        </>
    );
};

interface FormInputProps extends InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    type?: string;
    name: string;
    placeholder?: string;
    height?: string;
    register?: any;
    className?: string;
    labelClassName?: string;
    containerClass?: string;
    refCallback?: any;
    children?: any;
    rows?: string;
    errorText?: string;
    onFocus?: any;
    innerRef?: any
    icon?: any;
    onKeyDown?: (e: React.KeyboardEvent) => void;
    required?: boolean;
}

const FormInput2 = forwardRef<HTMLInputElement, FormInputProps>(({
    label,
    type,
    name,
    placeholder,
    register,
    className,
    height,
    labelClassName,
    containerClass,
    refCallback,
    children,
    rows,
    errorText,
    onKeyDown,
    onFocus,
    innerRef,
    icon,
    required,
    ...otherProps
}, ref) => {
    // handle input type
    const comp = type === 'textarea' ? 'textarea' : (type === 'select' ? 'select' : 'input');
    return (
        <>
            {type === 'hidden' ? (
                <input type={type} name={name} {...(register ? register(name) : {})} {...otherProps} />
            ) : (
                <>
                    {type === 'password' ? (
                        <>
                            <Form.Group ref={ref} className={containerClass}>
                                {label ? (
                                    <>
                                        {' '}
                                        <Form.Label style={{ marginBottom: "1px" }} className={labelClassName}>{label} {required ? <span className='from-group required'>*</span> : ''}</Form.Label> {children}{' '}
                                    </>
                                ) : null}
                                <PasswordInput
                                    name={name}
                                    placeholder={placeholder}
                                    refCallback={refCallback}
                                    register={register}
                                    className={className}
                                    onKeyDown={onKeyDown}
                                    {...otherProps}
                                />

                                {errorText && <Form.Control.Feedback type="invalid" className="d-block">
                                    {errorText}
                                </Form.Control.Feedback>}
                            </Form.Group>
                        </>
                    ) : (
                        <>
                            {type === 'checkbox' || type === 'radio' ? (
                                <>

                                    <Form.Group ref={ref} className={containerClass}>
                                        <Form.Check
                                            type={type}
                                            label={label}
                                            name={name}
                                            id={name}
                                            ref={(r: HTMLInputElement) => {
                                                if (refCallback) refCallback(r);
                                            }}
                                            className={className + 'align-middle'}
                                            {...(register ? register(name) : {})}
                                            {...otherProps}
                                            onKeyDown={onKeyDown}
                                        />

                                        {errorText && <Form.Control.Feedback type="invalid" className="d-block">
                                            {errorText}
                                        </Form.Control.Feedback>}
                                    </Form.Group>
                                </>
                            ) : (type === 'select' ?
                                <Form.Group ref={ref} className={containerClass}>
                                    {label ? <Form.Label style={{ marginBottom: "1px" }} className={labelClassName}>{label} {required ? <span className='from-group required'>*</span> : ''} {icon}</Form.Label> : null}

                                    <Form.Control
                                        type={type}
                                        placeholder={placeholder}
                                        name={name}
                                        id={name}
                                        style={{ lineHeight: height }}
                                        as={comp}
                                        ref={(r: HTMLInputElement) => {
                                            if (refCallback) refCallback(r);
                                        }}
                                        className={`form-select ${className}`}
                                        {...(register ? register(name) : {})}
                                        rows={rows}
                                        {...otherProps}
                                        onKeyDown={onKeyDown}
                                        autoComplete={name}
                                    >
                                        {children ? children : null}
                                    </Form.Control>

                                    {errorText && <Form.Control.Feedback type="invalid" className="d-block">
                                        {errorText}
                                    </Form.Control.Feedback>}
                                </Form.Group>
                                :

                                <Form.Group ref={ref} className={containerClass}>
                                    {label ? <Form.Label style={{ marginBottom: "1px" }} className={labelClassName}>{label} {required ? <span className='from-group required'>*</span> : ''}</Form.Label> : null}

                                    <Form.Control
                                        type={type}
                                        placeholder={placeholder}
                                        name={name}
                                        style={{ lineHeight: height }}
                                        id={name}
                                        as={comp}
                                        ref={(r: HTMLInputElement) => {
                                            if (refCallback) refCallback(r);
                                        }}
                                        className={className}
                                        {...(register ? register(name) : {})}
                                        rows={rows}
                                        {...otherProps}
                                        onKeyDown={onKeyDown}
                                        autoComplete={name}
                                    >
                                        {children ? children : null}
                                    </Form.Control>

                                    {errorText && <Form.Control.Feedback type="invalid" className="d-block">
                                        {errorText}
                                    </Form.Control.Feedback>}
                                </Form.Group>
                            )}
                        </>
                    )}
                </>
            )}
        </>
    );
});

export default FormInput2;
